import React from 'react'

const DiscardChanges = (props) => {
    const { discard, cancel, type } = props
    return (
        <div style={{ position: 'absolute', zIndex: 3 }}>
            <div className='discard-container-two'>
                <div className='center'>
                    <p className='discard-changes-header'>Discard Changes</p>
                    <p className='discard-changes-description'>Are you sure you want to discard the changes made to this marker?</p>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                        <button
                            onClick={cancel}
                            style={{ margin: '0', backgroundColor: 'grey', width: '45%' }}>Cancel</button>
                        <button
                            onClick={discard}
                            style={{ margin: '0', width: '45%' }}>Discard</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DiscardChanges